import { render } from "./ModalPrompt.vue?vue&type=template&id=a0df79b0&scoped=true"
import script from "./ModalPrompt.vue?vue&type=script&lang=js"
export * from "./ModalPrompt.vue?vue&type=script&lang=js"

import "./ModalPrompt.vue?vue&type=style&index=0&id=a0df79b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0df79b0"]])

export default __exports__